import React from "react";
import { Flex, Box, Icon, Text } from "@chakra-ui/react";

// A floating pill of actions pinned to the bottom of the screen. It floats
// over the page rather than boxing it in, so it's always one tap away without
// taking a row of layout.
//
// `items`: [{ id, label, icon, onClick, primary }]. The primary item is the
// filled one; the rest stay quiet until hovered.
export const FloatingNav = ({ items }) => (
  <Flex
    as="nav"
    aria-label="Directions and info"
    position="fixed"
    left="50%"
    bottom="calc(16px + env(safe-area-inset-bottom))"
    transform="translateX(-50%)"
    zIndex={20}
    gap="4px"
    p="6px"
    maxW="calc(100vw - 24px)"
    bg="rgba(26, 32, 44, 0.88)"
    backdropFilter="blur(14px)"
    border="1px solid"
    borderColor="whiteAlpha.200"
    borderRadius="full"
    boxShadow="0 10px 30px rgba(0, 0, 0, 0.45)"
  >
    {items.map((item) => (
      <Box
        key={item.id}
        as="button"
        type="button"
        onClick={item.onClick}
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="8px"
        h="44px"
        px={4}
        borderRadius="full"
        bg={item.primary ? "#817EFF" : "transparent"}
        color={item.primary ? "white" : "gray.300"}
        transition="all 0.15s ease"
        whiteSpace="nowrap"
        _hover={{
          bg: item.primary ? "#615EDC" : "whiteAlpha.200",
          color: "white",
        }}
        _active={{ transform: "scale(0.96)" }}
        sx={{ WebkitTapHighlightColor: "transparent" }}
      >
        <Icon as={item.icon} fontSize="15px" />
        <Text fontSize="14px" fontWeight={700} lineHeight="1">
          {item.label}
        </Text>
      </Box>
    ))}
  </Flex>
);

export default FloatingNav;
